import Vue from 'vue';

type DateValue = string|Date;

function intlFormat(value: DateValue, options: Intl.DateTimeFormatOptions) {
	return Intl.DateTimeFormat(
		Vue.prototype.$store.getLocale(),
		options
	).format(new Date(value));
}

export function formatDateLocal(value: DateValue) {
	return intlFormat(value, { day: "numeric", month: "numeric", year: "numeric" });
}

export function formatDateMonth(value: DateValue) {
	return intlFormat(value, { month: "long" });
}

export function formatDateMonthShort(value: DateValue) {
	return intlFormat(value, { month: "short" });
}

export function formatDateMonthYear(value: DateValue) {
	let locale = Vue.prototype.$store.getLocale();

	// format date for ru-RU locale without 'r.' at the end
	if (locale === 'ru-RU') {
		return `${intlFormat(value, { month: "long" })} ${intlFormat(value, { year: "numeric" })}`;
	}

	return intlFormat(value, { month: "long", year: "numeric" });
}

export function formatDateYear(value: DateValue) {
	return intlFormat(value, { year: "numeric" });
}

export function formatDateLocalISO(value: DateValue) {
	const date = new Date(value);

	const year = `${date.getFullYear()}`.padStart(2, '0');
	const month = `${date.getMonth() + 1}`.padStart(2, '0');
	const day = `${date.getDate()}`.padStart(2, '0');
	const hour = `${date.getHours()}`.padStart(2, '0');
	const minute = `${date.getMinutes()}`.padStart(2, '0');
	const second = `${date.getSeconds()}`.padStart(2, '0');

	return `${year}-${month}-${day}T${hour}:${minute}:${second}`;
}
